<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Nombre</th>
          <th>Total Mínimo</th>
          <th>Fecha Inicio</th>
          <th>Fecha Fín</th>
          <th>Usuario</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.id }}</td>
          <td>{{ current.nombre }}</td>
          <td>Q{{ current.precio_default }}</td>
          <td>{{ current.fecha_inicio }}</td>
          <td>{{ current.fecha_fin }}</td>
          <td><UsuarioEnTablaComponent :current="current.usuario" /></td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  computed: {
    ...mapGetters({}),
  },
  mounted() {
    this.$store.dispatch("reqtraslado/fetch");
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-escalas-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-escalas-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("reqtraslado/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
